export default "__VITE_ASSET__D917yygw__"